export default {
  footer:
    'footer-container pt-20 relative bg-white z-0 max-w-container mx-auto px-16 md:px-20 lg:px-0 md:pt-70',

  footerContainer: 'pl-60 pr-100 relative footer-menuBar',
  footerLinks:
    'justify-center no-underline uppercase text-black tracking-widest font-13 font-HelveticaNeueBold text-center footer-links footer-freehair',
  countrySelc: 'absolute top-0 right-0 language-change',
  subFooter: 'pt-50 sub-footer',
  subFooterlinksDesktop:
    'justify-center no-underline text-center subfooter-links hidden md:block',
  subFooterlinksMobile:
    'justify-center no-underline text-center subfooter-links md:hidden py-38 w-full mx-auto border-t-1 border-lightGrey border-solid',
  mobileView:
    'lg:hidden block justify-center no-underline pb-30  text-12 text-center footerpng-links',
  socialMedia: 'w-1/12 ml-25 social-media',
  discalimerContent:
    'w-full justify-center text-center text-grey-light leading-normal text-13 discalimer-content',
  'footer-accordian': '',
  footerLink: '',
  footerMainParent:
    'flex flex-col md:flex-row justify-between border-b-1 border-t-1 border-lightGrey border-solid md:py-20',
  footerMenuOne:
    'footer-left flex flex-col md:flex-row w-full md:w-50p md:whitespace-nowrap',
  footerNavDiv: 'footerNav w-full md:w-55p',
  footerLinksCollection:
    'footerLinksCollection font-HelveticaNeueMedium text-14 text-left flex flex-col px-20 py-30 md:p-0 md:ml-50 md:pl-50 md:border-l-1 md:border-lightGrey md:relative md:top-5 lg:w-40p',
  footerBrand:
    'footerBrand flex flex-col md:flex-row items-center pb-38 md:pb-0',
  footerCopyRiteDiv: 'font-HelveticaNeueMedium text-16 md:text-14 text-grey',
  brandbar: {
    imageList: 'mr-10 md:mr-25 float-left',
    imageStyle: 'h-px-30 h-24',
    mainDiv: 'border-b sm:hidden lg:block h-px-32 border-grey-darker',
    containerDiv: 'mx-auto container clearfix',
    brandText:
      'text-14 md:text-xs text-grey inline-block align-top font-HelveticaNeueMedium pb-20 md:pb-0',
    brandTextDivider:
      'bg-black-lighter h-3 w-px inline-block mx-15 mt-3 mb-0 align-top',
    imageListItem: 'brand-logo flex flex-row',
    footer1:'md:mr-[12] lg:mr-[12] footer1',
    linkDiv: 'text-grey-darker float-right mt-2 mb-0 lg:px-15 w-3/5 md:w-5/9',
    linkList:
      'user-links items-center font-sans-roma float-left w-3/4 text-right',
    linkListItem: 'inline-block align-top',
    linkAnchor:
      'text-xs text-grey-darker no-underline px-1 inline-block align-top',
    linkDivider: 'bg-grey-darker h-3 w-px inline-block align-top my-0',
    linkcrm: 'inline-block align-top',
    linkRegistor: 'text-xs text-grey-darker no-underline px-5 align-top',
    countrySelector: 'text-xs text-grey-darker no-underline px-1',
    linkAd: 'float-right block align-top -mt-1 w-1/5 text-right',
    adChoiceText: 'text-xs text-black text-grey-darker mt-1 font-sans-roma',
    userTextItem: 'inline-block align-top',
    welcomeText: 'text-xs text-grey-darkest px-1 inline-block align-top',
    userTextLink:
      'text-xs text-grey-darkest no-underline pr-10 inline-block align-top',
    logoutTextItem: 'inline-block align-top',
    logoutTextLink:
      'text-xs text-grey-darkest no-underline px-10 inline-block align-top',
    brandTextStyle:
      'flex flex-col md:flex-row w-full justify-between items-center pt-30 md:pt-20 pb-50',
    imgButton: 'inline-flex items-center justify-center md:justify-start adChoiceImg',
    imgButtonImg: 'py-10 pl-3 w-17 h-34',
  },
};
